export enum PatchOperations {
  unknown = 0,
  test = 1,
  remove = 2,
  add = 3,
  replace = 4,
  move = 5,
  copy = 6
}
